import { Link, X } from 'lucide-react';
import { useParams } from 'react-router-dom';

import IconButton from '@/components/Button/IconButton';
import useToastStore from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

export const FeedbackLinkCopyAction = ({
  feedbackAlias,
}: {
  feedbackAlias: string;
}) => {
  const params = useParams();
  const addDefaultToast = useToastStore((state) => state.addDefaultToast);

  const link = `${window.location.origin}/workspace/${params.workspace_id}/feedbacks/${feedbackAlias}`;

  const handleCopyLink = () => {
    clipboardCopy(link);
    addDefaultToast('Feedback link Copied', 'success');
  };

  return (
    <IconButton
      icon={<Link size={12} />}
      outlined={true}
      onClick={handleCopyLink}
      tooltip="Copy feedback link"
    />
  );
};

export const FeedbackCloseAction = ({
  closeModal,
}: {
  closeModal: () => void;
}) => {
  return (
    <IconButton
      onClick={closeModal}
      icon={<X size={12} />}
      tooltip="Close"
      shortcut="ESC"
    />
  );
};
